export enum WaitingPeriodType {
  EGGS = "EGGS",
  SLAUGHTER = "SLAUGHTER",
  MILK = "MILK",
  HONEY = "HONEY"
}
